var _title, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCharacter3 = function SvgCharacter3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "character-3")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "character-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,11 L11,12 L10,12 L10,13 L11,13 L11,14 L12,14 L12,15 L13,15 L13,16 L10,16 L10,15 L9,15 L9,14 L7,14 L7,15 L6,15 L6,16 L3,16 L3,15 L4,15 L4,14 L5,14 L5,13 L6,13 L6,12 L5,12 L5,11 L11,11 Z M4,10 L4,11 L3,11 L3,12 L4,12 L4,14 L1,14 L1,11 L2,11 L2,10 L4,10 Z M14,10 L14,11 L15,11 L15,14 L12,14 L12,12 L13,12 L13,11 L12,11 L12,10 L14,10 Z M9,12 L7,12 L7,13 L9,13 L9,12 Z M6,8 L6,9 L7,9 L7,8 L9,8 L9,9 L10,9 L10,8 L12,8 L12,9 L11,9 L11,10 L5,10 L5,9 L4,9 L4,8 L6,8 Z M11,0 L11,1 L12,1 L12,4 L11,4 L11,5 L5,5 L5,4 L4,4 L4,5 L5,5 L5,6 L11,6 L11,5 L12,5 L12,4 L14,4 L14,6 L13,6 L13,7 L3,7 L3,6 L2,6 L2,4 L4,4 L4,1 L5,1 L5,0 L11,0 Z M9,2 L6,2 L6,3 L9,3 L9,2 Z M6,1 L5,1 L5,2 L6,2 L6,1 Z",
    fill: "#000000"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCharacter3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/character-3.5d459a57.svg";
export { ForwardRef as ReactComponent };